import { z } from "zod"

export const tableCellAttrs = z.object({
  // key is null by default for the node, and set to UUID v4 when converting to
  // prismic format
  key: z.string().nullish(),
  colspan: z.number().nullish(),
  rowspan: z.number().nullish(),
  colwidth: z.array(z.number()).nullish(),
})
